module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-nav",
    class: _vm.getWidth
  }, [_c('div', {
    staticClass: "nav-top"
  }, [(_vm.isCollapse) ? [_c('img', {
    attrs: {
      "src": _vm.miniLogoUrl,
      "alt": ""
    }
  })] : [_c('img', {
    staticClass: "qianse_logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "shense_logo",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.ssLogoUrl,
      "alt": ""
    }
  })]], 2), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "text-color": "#fff",
      "default-active": _vm.navselected,
      "mode": "horizontal",
      "collapse": _vm.isCollapse,
      "collapse-transition": false
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    key: "home",
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "index": "home"
    }
  }, [_c('div', [_c('i', {}), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  })])]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return [(item.children) ? [_c('el-submenu', {
      key: index,
      attrs: {
        "label": _vm.Language(item.name),
        "value": item.id,
        "index": item.id,
        "title": _vm.Language(item.name)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "iconfont",
      class: _vm.getIcon(item.picCode)
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Language(item.name))), (item.qty && (item.qty > 0)) ? _c('b', {
      staticClass: "menu_num"
    }, [_vm._v(_vm._s(item.qty > 99 ? '99+' : item.qty))]) : _vm._e()])]), _vm._v(" "), _c('menu-tree', {
      attrs: {
        "menuData": item.children,
        "menuGroupName": item.name
      },
      on: {
        "menuClick": _vm.navListClick
      }
    })], 2)] : [_c('el-menu-item', {
      key: index,
      attrs: {
        "label": _vm.Language(item.name),
        "value": item.id,
        "index": item.name,
        "title": _vm.Language(item.name)
      },
      on: {
        "click": function($event) {
          return _vm.navListClick(item)
        }
      }
    }, [
      [_c('i', {
        staticClass: "iconfont",
        class: _vm.getIcon(item.menuGroupPicCode)
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(_vm.Language(item.name))), (item.qty && (item.qty > 0)) ? _c('b', {
        staticClass: "menu_num"
      }, [_vm._v(_vm._s(item.qty > 99 ? '99+' : item.qty))]) : _vm._e()])]
    ], 2)]]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "nav-bottom"
  }, [_c('div', {
    staticClass: "nav-bottom-r",
    class: {
      nav_bottom_l_hide: _vm.isCollapse
    },
    attrs: {
      "href": "javascript:;",
      "title": _vm.navToggleMsg
    },
    on: {
      "click": _vm.asideToggle
    }
  }, [_c('i', {
    staticClass: "font-14 iconfont",
    class: _vm.navToggleImg
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-20359a4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftNav/LeftNav.vue
// module id = 1324
// module chunks = 5